import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { TFunction } from 'i18next';
import MatchContent from './MatchContent';
import DtrContent from './DtrContent';
import TravelCostContent from './TravelCostContent';
import {
  DTR_SETTINGS_GROUP,
  TRAVELCOST_SETTINGS_GROUP
} from 'components/roster-portal/plan-units/Settings/constants';
import { MATCH_SETTINGS_GROUP } from '../constants';

enum selfMatch {
  NO_SELF_MATCH = 'NO_SELF_MATCH',
  SUBSCRIBE_SELF_MATCH = 'SUBSCRIBE_SELF_MATCH',
  CONNECT_SELF_MATCH = 'CONNECT_SELF_MATCH'
}

enum selfMatchFieldValue {
  NONE = 'NONE',
  SUBSCRIBE = 'SUBSCRIBE',
  CONNECT = 'CONNECT'
}

const selfMatchStaticRadioOptions = (t: TFunction) => [
  { label: t('none'), value: selfMatchFieldValue.NONE },
  { label: t('subscribe'), value: selfMatchFieldValue.SUBSCRIBE },
  { label: t('connect'), value: selfMatchFieldValue.CONNECT }
];

const useCreateSelfMatchRadioOptions = () => {
  const { getValues } = useFormContext();
  const { t } = useTranslation('common', { keyPrefix: 'selfMatch' });

  return useMemo(() => {
    return [
      { label: t('none'), value: 'NONE' },
      ...(getValues('self_match') === selfMatch.SUBSCRIBE_SELF_MATCH ||
      getValues('self_match') === selfMatch.CONNECT_SELF_MATCH
        ? [{ label: t('subscribe'), value: 'SUBSCRIBE' }]
        : []),
      ...(getValues('self_match') === selfMatch.CONNECT_SELF_MATCH
        ? [{ label: t('connect'), value: 'CONNECT' }]
        : [])
    ];
  }, [getValues('self_match')]);
};

const selfMatchOptions = (t: TFunction) => [
  { label: t('no_self_match'), value: selfMatch.NO_SELF_MATCH },
  { label: t('subscribe_self_match'), value: selfMatch.SUBSCRIBE_SELF_MATCH },
  { label: t('connect_self_match'), value: selfMatch.CONNECT_SELF_MATCH }
];

export const FormContent = ({ settingsGroup = MATCH_SETTINGS_GROUP }) => {
  const { control, getValues } = useFormContext();
  const selfMatchRadioOptions = useCreateSelfMatchRadioOptions();

  return (
    <>
      {settingsGroup === MATCH_SETTINGS_GROUP && (
        <MatchContent
          control={control}
          getValues={getValues}
          selfMatchOptions={selfMatchOptions}
          selfMatch={selfMatch}
          selfMatchRadioOptions={selfMatchRadioOptions}
          selfMatchStaticRadioOptions={selfMatchStaticRadioOptions}
        />
      )}

      {settingsGroup === DTR_SETTINGS_GROUP && <DtrContent control={control} />}

      {settingsGroup === TRAVELCOST_SETTINGS_GROUP && (
        <TravelCostContent control={control} />
      )}
    </>
  );
};
